import script from "./BetaPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./BetaPopup.vue?vue&type=script&setup=true&lang=js"

import "./BetaPopup.vue?vue&type=style&index=0&id=ac08b31e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac08b31e"]])

export default __exports__